import React, { useState, useEffect } from "react";

import {
  Container,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { filterByRegion, formatNumber, sortByName } from "../../helpers";
import Lookup from "./Lookup";
import "./style.css";
import { getCountryData } from "../../api";
import { regions, lookupCategories } from "../../data";

const MobileLookup = () => {
  const [currentCategory, setcurrentCategory] = useState("Capital");
  const [region, setRegion] = useState("World");
  const [countryData, setCountryData] = useState([]);

  useEffect(() => {
    const fetchCountryData = async () => {
      let data = await getCountryData();
      setCountryData(sortByName(filterByRegion([...data], region)));
    };
    fetchCountryData();
  }, [region]);

  const sortFormattedNumber = (a, b) =>
    +a.replace(/,/g, "") - +b.replace(/,/g, "");

  const getRankForCategory = (countryName) => {
    if (!["Population", "Density", "Area"].includes(currentCategory)) {
      return "-";
    }

    let countriesSortedByCategory = [...countryData].sort(
      (a, b) =>
        b[currentCategory.toLowerCase()] - a[currentCategory.toLowerCase()]
    );

    return (
      countriesSortedByCategory.findIndex(
        (country) => country.name === countryName
      ) + 1
    );
  };

  const columns = [
    { field: "id", headerName: "ID", hide: true },
    { field: "rank", headerName: "#", flex: 1, sortable: false },
    {
      field: "flag",
      headerName: "Flag",
      flex: 1,
      sortable: false,
      align: "center",
      renderCell: (params) => (
        <img
          height="20px"
          alt={params.value}
          src={params.value}
          style={{ aspectRatio: "3/2" }}
        />
      ),
    },
    { field: "country", headerName: "Country", flex: 4 },
    {
      field: "capital",
      headerName: "Capital",
      flex: 4,
      hide: currentCategory !== "Capital",
    },
    {
      field: "region",
      headerName: "Region",
      flex: 4,
      hide: currentCategory !== "Region",
    },
    {
      field: "population",
      headerName: `Population`,
      flex: 4,
      hide: currentCategory !== "Population",
      sortComparator: sortFormattedNumber,
    },
    {
      field: "area",
      headerName: `Area (km${"\u00B2"})`,
      flex: 4,
      hide: currentCategory !== "Area",
      sortComparator: sortFormattedNumber,
    },
    {
      field: "density",
      headerName: `Density`,
      flex: 4,
      hide: currentCategory !== "Density",
      sortComparator: sortFormattedNumber,
    },
  ];
  const rows = countryData.map((country, idx) => {
    return {
      id: idx + 1,
      rank: getRankForCategory(country.name),
      flag: country.flag,
      country: country.name,
      region: country.region,
      capital: country.capital,
      population: formatNumber(country.population),
      area: formatNumber(country.area),
      density: formatNumber(country.density),
    };
  });
  return window.innerWidth >= 725 ? (
    <Lookup />
  ) : (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
        width: "100%",
        overflow: "scroll",
      }}
    >
      <Box
        sx={{ display: "flex", width: "100%", justifyContent: "space-evenly" }}
      >
        <FormControl size="small" sx={{ width: "45%", margin: "1rem 0 0 0" }}>
          <InputLabel id="region-select">
            <Typography variant="overline">Region</Typography>
          </InputLabel>
          <Select
            id="region-select"
            value={region}
            onChange={(e) => {
              setRegion(e.target.value);
            }}
            label={<Typography variant="overline">Region</Typography>}
            MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
          >
            {regions.map((option, idx) => {
              return (
                <MenuItem value={option} key={idx + 1}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ width: "45%", margin: "1rem 0 0 0" }}>
          <InputLabel id="current-category-select">
            <Typography variant="overline">Category</Typography>
          </InputLabel>
          <Select
            id="current-category-select"
            value={currentCategory}
            onChange={(e) => {
              setcurrentCategory(e.target.value);
            }}
            label={<Typography variant="overline">Category</Typography>}
            MenuProps={{ PaperProps: { sx: { maxHeight: 350 } } }}
          >
            {lookupCategories.map((option, idx) => {
              return (
                <MenuItem value={option} key={idx + 1}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ height: "100vh", width: "100%", margin: "auto" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableExtendRowFullWidth
          getRowHeight={() => "auto"}
          rowsPerPageOptions={[10, 20, 50, 100]}
          sx={{ border: "none" }}
        />
      </Box>
    </Container>
  );
};

export default MobileLookup;
